<template>
	<div class="display_wrapper">

		<div grey-back full-height id="non-printable">
			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">
			    	{{fixedTabs ? displayData.name : 'Item'}}
			    	<div toolbar-subtitle v-if="fixedTabs">
			    		<span v-for="(item, index) in summaryArray" v-if="summaryArray && summaryArray.length">
		           			<span :class="{'redcolor':item.qty < 0}">{{item.roundOffQty != undefined ? item.roundOffQty : roundUpto2Decimals(item.qty)}} {{item.unitName}}</span> 
		           		</span>
			    	</div>
			    </v-toolbar-title>

			    <v-spacer></v-spacer>

				<v-btn icon @click="fn_barcode" class="mr-2" v-if="$root.appVersion >= 325">
					 <img width="30" src="../../../../assets/barcode_printer_72.png" alt="barcode_print">
				</v-btn>

		    	<v-btn icon @click="fn_edit"><v-icon>edit</v-icon></v-btn>

		    	<v-btn icon @click="fn_getBottomMenu" v-if="displayData && (!displayData.inventory || displayData.groupTypeId != 101) ">
			      <v-icon>more_vert</v-icon>
			    </v-btn>
			</v-toolbar>

			<div class="display hasToolbar hasBigFooterWithExtention" v-scroll="onScroll">

				<div id="top_section" v-if="displayData">
					<v-list auto-height-tile :three-line="displayData.groupTypeId==101 ? true : false" :two-line="displayData.groupTypeId!=101 ? true : false">
						<v-list-tile>
							<v-list-tile-content>
								<v-list-tile-title class="mb-1" style="white-space:normal !important;overflow: visible !important;height:auto;">{{displayData.name}}</v-list-tile-title>
								
								<!-- <v-list-tile-title class="mb-1" v-if="displayData.groupTypeId==101">
									<span v-for="(item, index) in summaryArray" v-if="summaryArray && summaryArray.length">
					           			<span :class="{'redcolor':item.qty < 0}">{{item.qty}} {{item.unitName}}</span>
					           		</span>
								</v-list-tile-title> -->

								<template v-if="displayData.groupTypeId==101">
                                    <v-list-tile-sub-title class="mb-1">
                                        Purchase Rate:&nbsp;<span>&#8377; {{displayData.purchaseRate ? $root.numberToLocale(displayData.purchaseRate) : '0'}}</span>
                                    </v-list-tile-sub-title>

                                    <v-list-tile-sub-title class="mb-1">
                                        Sale Price:&nbsp;<span>&#8377; {{displayData.sellingPrice ? $root.numberToLocale(displayData.sellingPrice) : '0'}}</span>&nbsp;
                                    </v-list-tile-sub-title>
                                </template>

                                <template v-else>
                                    <v-list-tile-sub-title class="mb-1">
                                        Charges:&nbsp;<span>&#8377; {{displayData.charges ? $root.numberToLocale(displayData.charges) : '0'}}</span>
                                    </v-list-tile-sub-title>    
                                </template>

								<v-chip small v-if="displayData.status == 0">This item is De-Activated</v-chip>
							</v-list-tile-content>
							<v-list-tile-action v-if="displayData.groupTypeId==101" style="position: absolute;right: 16px;bottom: 10px;align-items: flex-end;">
                                <template v-for="(item, index) in summaryArray">
                                    <span :key="index" v-if="summaryArray && summaryArray.length" font16>
                                        <span :class="{'redcolor':item.qty < 0}">{{item.roundOffQty != undefined ? item.roundOffQty : roundUpto2Decimals(item.qty)}} {{item.unitName}}</span>
                                    </span>    
                                </template>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>

					<!-- <v-list two-line>
						<v-list-tile font20>
							<v-list-tile-content>
								<v-list-tile-title style="height:32px">{{displayData.name}}</v-list-tile-title>
								<v-list-tile-title style="font-weight:500" v-if="displayData.groupTypeId==101">
									<span v-for="(item, index) in summaryArray" v-if="summaryArray && summaryArray.length">
					           			<span :class="[item.qty < 0 ? 'redcolor' : 'greencolor']">{{item.qty}} {{item.unitName}}</span>
					           		</span>
								</v-list-tile-title>
								<v-list-tile-title style="font-weight:500" v-else>-</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list> -->

				</div>

				<v-divider></v-divider>

			    <!-- <v-tabs v-model="activeIndex" fixed-tabs @input="fn_tabChange" slider-color="primary" class="fix_width_tabcount2"> -->
			    <v-tabs v-model="activeIndex" @input="fn_tabChange" slider-color="primary">
			        <v-tab v-for="(tab, index) in tabs" :key="index" ripple>{{tab.title}}</v-tab>
			    </v-tabs>

			    <v-tabs-items v-model="activeIndex" @input="fn_tabChange">

			    	<v-tab-item>  
			        	<keep-alive>
			        		<activity-tab ref="ref_activity" :productId="displayData.productId" :preview="fn_preview" :bindInvoiceTemplate="fn_bindInvoiceTemplate" :getFormNameByListId="$root.fn_getFormNameByListId" v-if="displayData"></activity-tab>
			        	</keep-alive>
			      	</v-tab-item>

			      	<v-tab-item>  
			        	<keep-alive>
			         		<details-tab ref="ref_details" :displayData="displayData" :summaryArray="summaryArray" v-if="displayData"></details-tab>
			        	</keep-alive>
			      	</v-tab-item>

			    </v-tabs-items>

			    <v-footer class="invoice-footer-actions" v-if="displayData && (displayData.inventory && displayData.groupTypeId == 101)">
			    	<v-layout grid white-background wrap text-xs-center>

						<v-flex xs4 sm4 md4 pt-2 pb-2 v-ripple @click="fn_adjustStock('plus')">
							<div right-border>
								<div><v-icon>add_circle_outline</v-icon></div>
						    	<div font11 class="font-weight-bold">Add Stock</div>
							</div>	
						</v-flex>

						<v-flex xs4 sm4 md4 pt-2 pb-2 v-ripple @click="fn_adjustStock('minus')">
						    <div right-border>
						    	<div><v-icon>remove_circle_outline</v-icon></div>
						    	<div font11 class="font-weight-bold">Reduce Stock</div>
						    </div>
						</v-flex>

						<v-flex xs4 sm4 md4 pt-2 pb-2 v-ripple @click="fn_getBottomMenu">
						    <div>
						    	<div><v-icon>more_horiz</v-icon></div>
						    	<div font11 class="font-weight-bold">More</div>
						    </div>
						</v-flex>
					</v-layout>	
			    </v-footer>
			    
			</div>

			<!-- binding in the background to calculate full page height for header, body and footer -->
			<div id="hidden_invoice_preview" v-if="$root.TransactionSettings.fullPagePrint">
				<component :is="previewTemplate" ref="ref_previewTemplate" :data="printData" v-if="previewTemplate && printData!=null"></component>
			</div>

		</div>

		<div white-background id="printable" full-width>
	      <component :is="printTemplate" ref="ref_printTemplate" :data="printData" v-if="printTemplate && printData!=null"></component>
	    </div>

		<dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteProductAndOpening" params="delete" :displayView='true'></dialog-confirmation>

	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const productTabConfigs = require('../../../../config.js').configs.productTabConfigs;

const dialogjs =  require('../dialog').dialogjs;


import {masterMixin} from '../../master_mixin.js'
import activityTab from './display_tabs/activity'
import detailsTab from './display_tabs/details'

import dialogConfirmation from '../../../dialogs/dialog_confirmation'
import {transactionMixin} from '../../../transactions/transaction_mixin'

	export default{
		mixins: [masterMixin, transactionMixin],
		components: {
			'activity-tab': activityTab,
		    'details-tab': detailsTab,
		    'dialog-confirmation': dialogConfirmation
		},
		data(){
			return{
				displayData:null,
				summaryArray:null,
				defaultVariantName:null,
				tabs:[
					{"id":1, "title":"Activity"},
		            {"id":2, "title":"Details"}
		        ],
		        // currentBalance:null,
		        activeIndex:0,
		        offsetTop: 0,
		        fixedTabs:false,
		        isGoBack:false,
		        formId:null,
		        dialogStorageId:null,
		        printData:null,
        		printTemplate:null,
				previewTemplate:null,
			}
		},
		methods:{

			// fn_openDialogWeb: function (platform, name, ref) {

			// 	let scroll_y = window.scrollY;
			// 	this.fn_fixBackgroundScroll();

			// 	var tagId = this.guidWeb();

			// 	var dialogObj = {};
			// 	dialogObj.tagId = tagId;
			// 	dialogObj.formId = this.formId;
			// 	dialogObj.name = name;
			// 	dialogObj.ref = ref;
			// 	dialogObj.data = null;
			// 	dialogObj.platform = platform;

			// 	dialogObj.scrollPosition = {};
			// 	dialogObj.scrollPosition.x = 0;
			// 	dialogObj.scrollPosition.y = scroll_y;

			// 	dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

			// 	this.$refs[ref].openDialogWeb();
			// },

			// fn_closeDialog: function(){
			// 	dialogjs.fn_checkAndCloseOpenDialogs(this);
			// },
			fn_preview: function(item, formNameFn){
		        item.toolbarTitle = formNameFn ? formNameFn(item.transactionListId) : 'order';
		        let printType = item.invoiceTemplate == 101 ? 'ab' : item.invoiceTemplate == 201 ? 'sj' : null;

		        let type = null;
		        if(item.transactionListId == 10001 || item.transactionListId == 10002 || item.transactionListId == 10003 || item.transactionListId == 10004 || item.transactionListId == 10005){
		          type = 'sales';
		        }
		        else if(item.transactionListId == 20001 || item.transactionListId == 20002 || item.transactionListId == 20003 || item.transactionListId == 20004 || item.transactionListId == 20005){
		          type = 'purchase';
		        }
		        else if(item.transactionListId == 40002 || item.transactionListId == 40005 || item.transactionListId == 40006){
		          type = 'inventory';
		        }

				if(item.transactionListId == 40005)
					printType = 'st'
				if(item.transactionListId == 40006)
					printType = 'bm'
		        
		        this.fn_previewInvoice(true, type, printType, item);
		    },

		    fn_bindInvoiceTemplate: function(type, item){

		        this.printTemplate = null;
		        this.printData = null;
				this.previewTemplate = null;

				let templateNo = item.transactionListId == 40005 ? 301 : item.transactionListId == 40006 ? 302 : item.invoiceTemplate;

		        // this.printTemplate = require('../../../invoice_templates/invoices/template'+item.invoiceTemplate).default;
		        if(this.$root.TransactionSettings.fullPagePrint && templateNo != 101 && templateNo != 301 && templateNo != 302){
          			this.previewTemplate = require('../../../invoice_templates/invoices/template'+item.invoiceTemplate).default;
					this.printTemplate = require('../../../invoice_templates/invoices/template1001').default;
				}
				else{
					this.printTemplate = require('../../../invoice_templates/invoices/template'+templateNo).default;
				}
				// this.printTemplate = require('../invoice_templates/invoices/template1').default;
		        console.log(this.printTemplate);

		        // let dataFnName = item.invoiceTemplate == 101 ? 'AccountBookPrintData' : item.invoiceTemplate == 201 ? 'StockJournalPrintData' : 'InvoiceData';
				let dataFnName = templateNo == 101 ? 'AccountBookPrintData' : templateNo == 201 ? 'StockJournalPrintData' : templateNo == 301 ? 'StockTransferInvoiceData' : templateNo == 302 ? 'BOMInvoiceData' : 'InvoiceData';
				
		        if(type=='sharewhatsapp'){
		          this.fn_shareInvoice('sharewhatsapp', item, dataFnName);
		        }
		        else if(type=='print'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'print', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='pdf'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='share'){
		          this.fn_shareInvoice('share', item, dataFnName);
		        }
				else if(type=='thermal'){
					this.fn_getPrintData(dataFnName, item.transactionId, 'thermal', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }

				setTimeout(() => {
					this.previewTemplate = null;
				}, 5000);
		    },

		    fn_shareInvoice: function(type, item, dataFnName){

		    	let title = null;
		        if(item.transactionListId==10003){
		            title = "Invoice";
		        }
		        else{
		            title = this.fn_getTransactionTitle(item.transactionListId);    
		        }

		    	// if(item.transactionTypeFormName.toLowerCase() == "itc not eligible"){
		     //      item.transactionTypeFormName = "Expense";
		     //    }

		     //    if(item.transactionTypeFormName == "Retail Invoice" || item.transactionTypeFormName == "Wholesale Invoice" || item.transactionTypeFormName == "Export Invoice" || item.transactionTypeFormName ==  "Stock Transfer"){
		     //        item.transactionTypeFormName = "Invoice";
		     //    }

			 	if(item.transactionPhoneNumber){
					item.primaryMobileNumber = item.transactionPhoneNumber;
				}
        
		        let shareObj = {};
		        shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
		        shareObj.type = 'pdf';
		        shareObj.primaryMobileNumber = item.primaryMobileNumber && type == 'sharewhatsapp' ? item.primaryMobileNumber : null;
		        // shareObj.subject = title + " Details";
				shareObj.subject = title + " #" + item.mergeTransactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
		        shareObj.email = item.email ? [item.email] : null ;

		        let party = item.partyName ? item.partyName + ',' : '';

        		// shareObj.textMessage = "Dear "+party+"\n\nBelow are your " + title + " details. Please find the attached pdf.\n\nTransaction Date: "+this.$moment(item.transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(item.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
				shareObj.textMessage = this.$tShare('share.invoiceMessage', {
					party: party,
					title: title,
					number: item.mergeTransactionNumber,
					date: this.$moment(item.transactionDate).format('DD-MMM-YYYY'),
					amount: this.$root.numberToLocale(item.roundedAmount),
					businessName: this.$root.CurrentBusiness.BusinessName
				});
				
		        // shareObj.textMessage = "Dear "+item.accountLedgerName+",\n\nBelow are your invoice details. Please find the attached pdf of your invoice.\n\nInvoice Date: "+this.$moment(item.createdDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(item.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
		        this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', shareObj, item.mergeTransactionNumber, null, item.transactionListId);
		      },

			fn_tabChange:function(tabIndex){
				productTabConfigs.activeIndex = tabIndex;
			},

			onScroll (e) {
		        this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
		        // let topSectionHeight = document.getElementById('top_section').offsetHeight;
		        // if(this.offsetTop >= topSectionHeight){
		        if(this.offsetTop>60){
		        	this.fixedTabs = true;
		        }
		        else{
		        	this.fixedTabs = false;
		        }
		    },

		    fn_adjustStock(type){
				this.$router.push({path:"/transactions/inventory/stockadjustment/items/new", query:{tagId:this.guidWeb(), type:type, itemid:this.displayData.productId}});
			},

			fn_get: function(itemId){
				var self = this;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);

				          let variants = self.displayData.productVariants;
						  let defaultVariant;

				          for(var i=0; i<variants.length; i++){

				          	if(variants[i].isDefault){
				          		defaultVariant = variants[i];
				          		self.defaultVariantName = variants[i].unitName

				          		// defaultVariant.sellingPrice ? self.sellingPrice = defaultVariant.sellingPrice : '';
				          		// defaultVariant.wholeSalePrice ? self.wholeSalePrice = defaultVariant.wholeSalePrice : '';
				          		// defaultVariant.mrp ? self.mrp = defaultVariant.mrp : '';

				          		if(variants.length>1){ //moving default variant to top
				          			self.displayData.productVariants.splice(i, 1);
				          			self.displayData.productVariants.unshift(defaultVariant);
				          		}

				          		break;
				          	}
				          }

				          self.fn_getSummary(itemId);

						  self.fn_getProductBatches();


				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getSummary: function (itemId) {
				var self = this;
				this.getData('ProductSummary', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.summaryArray = JSON.parse(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getProductBatches: function(){
				let self = this;
				this.getData('GetProductBatchByProductId', this.displayData.productId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.displayData.batches = JSON.parse(response);
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Items";
				viewObject.TopMenu = [{"MenuID":3, "MenuType":null, "Icon":null, "Text":"Edit", "Action":"edit"}]
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';

				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				let activeDeactiveMenu = this.displayData.status == 0 ? menuItem.activate : menuItem.deactivate; 
				var bottomMenu = {"BottomMenu": [menuItem.copy]};
				if(this.$root.appVersion >= 297){
					bottomMenu.BottomMenu.push(activeDeactiveMenu);
				}
				!this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.productId){
					this.fn_edit();
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), itemId:this.displayData.productId, copy:true}});
				}
				else if(menuAction=='deactivate'){
					this.fn_activateToggle(0);
				}
				else if(menuAction=='activate'){
					this.fn_activateToggle(1);
				}
				else if(menuAction=='delete'){
					// let self = this;
					// this.fn_deleteMasterItem('products', this.displayData.productId, function(response){
					// 	if(response){
	    //                     self.showToast('Item deleted');
	    //                     self.$router.go(-1);
	    //                 }
	    //                 else{
	    //                     self.showToast("Item cannot be deleted as already in use");
	    //                 }
					// })
					this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
					// this.fn_deleteProductAndOpening();
				}
			},

			fn_deleteProductAndOpening: function(){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
	            let self = this;
	            let filterObject = {};
	            filterObject.productId = this.displayData.productId;
	            if(this.displayData.opening && this.displayData.opening.transactionId){
	            	filterObject.transactionId = this.displayData.opening.transactionId;
	            }
	            this.postFilterData('deleteProductWithOpening', null, filterObject, {

	                onSuccess: function(response){
	                    
	                    console.log(response);
	                    if(JSON.parse(response)){
	                        self.showToast('Item deleted');
	                        self.fn_goBack();
	                    }
	                    else{
	                        self.showToast("Item cannot be deleted as already in use");
	                    }
	                }, 
	                onError: function(error){
	                    console.log(error);
	                }
	            });
	        },

			fn_edit: function () {
				this.$router.push("/masters/inventory/productandservices/items/"+this.displayData.productId+"/edit");
			},

			fn_activateToggle: function(status){
				let self = this;
				let dataObj = {productId:this.displayData.productId, "status":status};
				this.postData('AddProductToArchive', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
							self.displayData.status = status;
							self.showToast(status == 0 ? 'Item de-activated' : 'Item activated')
				        },
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_barcode: function(){
				this.$router.push({path:"/barcode/generator", query:{tagId:this.guidWeb(), itemId:this.displayData.productId, itemName:this.displayData.name}});
			},

			fn_goBack: function(){
				this.isGoBack = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;
			
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				if(!this.isGoBack && !localStorage.getItem("transaction_items_state")){
					localStorage.setItem("scroll_top", 1);
				}
				else{
					localStorage.removeItem("scroll_top");
				}
				next(true);
			}
	    }
	}

</script>

<style>
	[space-even], .space-even{
		justify-content: space-evenly !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/masters/forms/product/display.vue